module.exports = __webpack_public_path__ + "img/mm.6d702a74.svg";